export default __webpack_public_path__ + "static/char-s-sp02-cht-c5ed0ace5adb4be6f3cab99bd0ce4bce.webp";